import { pick } from 'Helpers/Affordances';
import fr from 'facet-rest';
import React from 'react';
import PropTypes from 'prop-types';
import useSimpleHousehold from 'Hooks/useSimpleHousehold';
import Email from './Email';


const EmailPicker = ({ resource }) => {
  const {
    householdResource,
    household,
  } = useSimpleHousehold();

  return pick(resource, {
    [fr.relationships.householdSectionMember.name]: null,
  }, (
    <Email
      householdResource={householdResource}
      household={household}
    />
  ));
};

EmailPicker.propTypes = {
  resource: PropTypes.instanceOf(fr.Resource).isRequired,
};
EmailPicker.defaultProps = {};

export default EmailPicker;
